import script from "./SendEmailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SendEmailForm.vue?vue&type=script&setup=true&lang=js"

import "./SendEmailForm.vue?vue&type=style&index=0&id=6567d31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6567d31a"]])

export default __exports__